import type { IPlace } from "@bbj-types/address";
import type { IStructurePartner } from "@bbj-types/structurePartner";
import { useCallback } from "react";
import { axiosStructurePartner } from "./axios";

interface IFindAllStructurePartnersParams {
  search: string;
}

export type TFindAllStructurePartnersResponse = (Pick<IStructurePartner, "_id" | "name"> & {
  place?: Pick<IPlace, "_id" | "placeLabel">;
})[];

export const useFindAllStructurePartners = () => {
  const [state, execute, cancel] = axiosStructurePartner<TFindAllStructurePartnersResponse>(
    {
      url: "/find/all",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (params: IFindAllStructurePartnersParams) => {
      return execute({
        params,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
